// Extrae el código/mensaje de error de lo que rechaza axios.
// El interceptor de `src/utils/axios.js` rechaza con el CUERPO de la
// respuesta (no con el error de axios), y según el endpoint ese cuerpo es
// un string ("ADDON_ALREADY_ACTIVE"), `{ code }`, `{ message }` o el formato
// del ExceptionMiddleware `{ Message, StatusCode, TraceId }`. También se
// tolera el error de axios clásico (`err.response.data`).
export function apiErrorText(err) {
  if (err == null) return "";
  if (typeof err === "string") return err;
  const data = err.response?.data;
  const candidates = [
    err.code,
    err.errorCode,
    err.Code,
    err.message,
    err.Message,
    typeof data === "string" ? data : null,
    data?.code,
    data?.errorCode,
    data?.message,
    data?.Message,
  ];
  const found = candidates.find((c) => typeof c === "string" && c.trim() !== "");
  return found || "";
}

/** true si el error contiene el código dado (p. ej. "ADDON_ALREADY_ACTIVE"). */
export function hasApiErrorCode(err, code) {
  if (!code || err == null) return false;
  if (typeof err === "string") return err.includes(code);
  const data = err.response?.data;
  const all = [
    err.code, err.errorCode, err.Code, err.message, err.Message,
    data, data?.code, data?.errorCode, data?.message, data?.Message,
  ];
  return all.some((v) => typeof v === "string" && v.includes(code));
}
